<div class="history-container">
  <h3 class="header">
    <mat-icon>history</mat-icon>
    Inspection Events History
  </h3>

  @if (dataLoaded) {
    <div>
      @for (event of events; track event) {
        <div class="event">
          <div class="event-meta">
            <span class="eventDate">{{ event.eventDate }}</span>
            <p class="userName">{{ event.userName }}</p>
          </div>
          <div class="event-details">
            <strong class="action">{{ event.action }}</strong>
            @for (line of event.description; track line) {
              <div class="description">
                {{ line }}
              </div>
            }
            @if (event.document != null) {
              <div>
                <p class="download" (click)="downloadDocument(event.document)">
                  Link to Attached Document
                </p>
              </div>
            }
          </div>
        </div>
      }
      <div class="pagination">
        <button
          [disabled]="currentPage === 0"
          (click)="previousPageButton()"
          mat-icon-button
          color="primary"
          >
          <mat-icon>chevron_left</mat-icon>
        </button>
        @if (currentPage != 0) {
          <p class="disabled">{{ currentPage }}</p>
        }
        <p class="enabled">{{ currentPage + 1 }}</p>
        @if (!lastPage) {
          <p class="disabled">{{ currentPage + 2 }}</p>
        }
        <button
          [disabled]="lastPage"
          (click)="nextPageButton()"
          mat-icon-button
          color="primary"
          >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  }
  @if (!dataLoaded) {
    <mat-spinner diameter="32"></mat-spinner>
  }
</div>
